import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import { Star } from 'lucide-react'

const STAR_VALUES = ['1', '2', '3', '4', '5'] as const
export type ReviewStarValue = (typeof STAR_VALUES)[number]

export const ReviewStars = ({
  onChange,
  value,
  disabled,
  selectedValue,
}: Readonly<{
  onChange: (value: string) => void
  selectedValue: string
  value?: string
  disabled?: boolean
}>) => (
  <ToggleGroup
    type='single'
    className='gap-1'
    onValueChange={onChange}
    value={value}
    disabled={disabled}
  >
    {STAR_VALUES.map((value) => (
      <ToggleGroupItem unstyled className='outline-fig-300' key={value} value={value}>
        <Star
          width={20}
          strokeWidth={1}
          className={
            parseInt(selectedValue) >= parseInt(value)
              ? 'fill-[#E8715B] text-[#E8715B]'
              : 'text-neutral-150'
          }
        />
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
)
